const FOOTER_CONFIG = {
    ['depositexpired']: {
        example1: 'contractsView-contractsView_depositExpiredExamplesList1',
        example1Full: 'contractsView-contractsView_depositExpiredExamplesList1Full',
        example2: 'contractsView-contractsView_depositExpiredExamplesList2',
        example3: 'contractsView-contractsView_depositExpiredExamplesList3',
    },
    ['depositrenewal']: {
        example1: 'contractsView-contractsView_depositRenewalExamplesList1',
        example1Full: 'contractsView-contractsView_depositRenewalExamplesList1Full',
        example2: 'contractsView-contractsView_depositRenewalExamplesList2',
        example3: 'contractsView-contractsView_depositRenewalExamplesList3',
    },
    ['deposittransfer']: {
        example1: 'contractsView-contractsView_depositTransferExamplesList1',
        example1Full: 'contractsView-contractsView_depositTransferExamplesList1Full',
        example2: 'contractsView-contractsView_depositTransferExamplesList2',
        example3: 'contractsView-contractsView_depositTransferExamplesList3',
    }
}

module.exports = {
    FOOTER_CONFIG,
}
